import $x from '@/utils/$x';

/// 合伙人列表
export async function queryPartnerList(params) {
  return $x.post('/partner/manager/pageList', params);
}
/// 合伙人列表
export async function addPartner(params) {
  return $x.post('/partner/manager/addPartner', params);
}
/// 合伙人审核
export async function partnerAuditing(params) {
  return $x.post('/partner/manager/partnerAuditing', params);
}
/// 合伙人基础信息编辑
export async function partnerBaseInfoModify(params) {
  return $x.post('/partner/manager/partnerBaseInfoModify', params);
}
/// 合伙人结算信息编辑
export async function partnerSettleModify(params) {
  return $x.post('/partner/manager/partnerSettleModify', params);
}
/// 查询合伙人信息
export async function queryPartner(params) {
  return $x.post('/partner/manager/queryPartner', params);
}
/// 删除合伙人信息
export async function deletePartner(params) {
  return $x.post('/partner/manager/deletePartner', params);
}
/// 绑定商家首页
export async function bindingTenantPageList(params) {
  return $x.post('/partner/manager/bindingTenantPageList', params);
}
/// 新增绑定
export async function addBinding(params) {
  return $x.post('/partner/manager/addBinding', params);
}
/// 启用/停用绑定关系
export async function changBindingTenantStatus(params) {
  return $x.post('/partner/manager/changBindingTenantStatus', params);
}
/// 删除绑定关系
export async function deleteBinding(params) {
  return $x.post('/partner/manager/deleteBinding', params);
}
